import { useTranslations } from "use-intl";

import { MemoryContext } from "./components/memory-context";
import { MemoryFiles } from "./components/memory-files";

export function MemoryPage() {
	const t = useTranslations("memory");

	return (
		<div className="flex flex-col gap-6">
			<h1 className="text-2xl font-semibold">{t("title")}</h1>
			<MemoryContext />
			<MemoryFiles />
		</div>
	);
}
